<div class="footer-container">
  <div class="container">
    <div class="footer-inner-container">
      {{ 'FOOTER.COPYRIGHT' | translate: { currentYear: currentYear } }}
    </div>
  </div>
</div>
